module.exports = __webpack_public_path__ + "img/mannul_vip.7fe3e513.png";